package one.devsbox.www.tools

data class ArgsId(var id: Long = -1)
data class ArgsIdWithParent(var id: Long = -1, var parentId: Long = -1)